import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { getData } from "../../../../utils/api";
import { Select2Data } from "../../../../utils/common";
import Select from "react-select";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getDimension } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [countLang, setCountLang] = useState([]);

  const {
    control,
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: {
      languages: [],
    },
  });

  const { fields } = useFieldArray({
    control,
    name: "languages",
  });

  const getLanguges = async () => {
    const response = await getData("/without-login/masters/all-languages");
    setCountLang(response.data);

    reset({
      languages: response.data.map((lang) => ({
        language_id: lang.id,
        question: "",
        answer: "",
      })),
    });
  };

  useEffect(() => {
    getLanguges();
  }, []);
  const descriptionValue = watch("description");
  // const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      // console.log(data);

      const sendData = new FormData();
      sendData.append("faq_category_id", data.faq_category_id?.value);
      sendData.append("answer", data.languages[0]?.answer);
      sendData.append("question", data.languages[0]?.question);
      sendData.append("languages", JSON.stringify(data.languages));

      const response = await postData(`/masters/faq`, sendData);
      // console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };
  const [faqCategory, setFaqCategory] = useState([]);
  const GetAllfaqcategory = async () => {
    const response = await getData("/without-login/masters/all-faq-category");

    if (response?.success) {
      setFaqCategory(await Select2Data(response?.data, "faq_category_id"));
    }
  };
  useEffect(() => {
    GetAllfaqcategory();
  }, []);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add FAQ</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Add FAQ</Card.Title>
              <hr />
              <Container>
                <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
                  <Row>
                    <Col md={12}>
                      <Form.Label column sm={3}>
                        FAQ Category
                      </Form.Label>
                      <Col sm={6}>
                        <Controller
                          name="faq_category_id" // name of the field
                          {...register("faq_category_id", {
                            required: "Select FAQ Category",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors.faq_category_id
                                    ? "red"
                                    : baseStyles,
                                }),
                              }}
                              {...field}
                              options={faqCategory}
                            />
                          )}
                        />
                      </Col>
                    </Col>

                    {fields.map((field, index) => (
                      <React.Fragment key={field.id}>
                        {/* Question */}
                        <Col md={12}>
                          <Form.Label column sm={3}>
                            Question ({countLang[index]?.name})
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Control
                              type="text"
                              placeholder={`Enter Question in ${countLang[index]?.name}`}
                              {...register(`languages.${index}.question`, {
                                required: `Question is required in ${countLang[index]?.name}`,
                              })}
                            />
                            {errors.languages?.[index]?.question && (
                              <span className="text-danger">
                                {errors.languages[index].question.message}
                              </span>
                            )}
                          </Col>
                        </Col>

                        {/* Answer */}
                        <Col md={12}>
                          <Form.Label column sm={3}>
                            Answer ({countLang[index]?.name})
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Control
                              type="text"
                              placeholder={`Enter Answer in ${countLang[index]?.name}`}
                              {...register(`languages.${index}.answer`, {
                                required: `Answer is required in ${countLang[index]?.name}`,
                              })}
                            />
                            {errors.languages?.[index]?.answer && (
                              <span className="text-danger">
                                {errors.languages[index].answer.message}
                              </span>
                            )}
                          </Col>
                        </Col>
                      </React.Fragment>
                    ))}

                    <Row className="mt-5 pb-3">
                      <div className="d-flex justify-content-center">
                        <Link>
                          <CancelButton
                            name={"cancel"}
                            handleClose={props.handleClose}
                          />
                        </Link>
                        <SaveButton
                          name={"save"}
                          handleSubmit={handleSubmit(onSubmit)}
                        />
                      </div>
                    </Row>
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
